module.exports = __webpack_public_path__ + "img/print-complete_faceberry.06c37624.png";